import { Header } from '../../shared/components';
import { EmptyState } from '../../shared/components';

/**
 * Pagina placeholder para modulos anunciados en la especificacion pero aun no
 * desarrollados (Despachos, Inventario, Operarios, Dashboard, KPIs, Reportes, Ayuda).
 * Al implementarse, solo se agrega su carpeta en /modules y se cambia el status
 * a "active" en shared/config/modules.ts — sin tocar navegacion (Open/Closed).
 */
export function ComingSoonPage({ title }: { title: string }) {
  return (
    <div>
      <Header title={title} />
      <div className="p-4">
        <EmptyState icon="🚧" title="Módulo en construcción" description="Este módulo estará disponible próximamente dentro de la Suite Logistics Control Center." />
      </div>
    </div>
  );
}
